/* MerchBytes theme — behaviour ported 1:1 from the static site.
   Address data now comes from theme settings via window.MB_ADDRESSES
   (see sections/footer.liquid); the defaults below are only a fallback. */
(function () {
  'use strict';

  /* ---------- Footer year ---------- */
  var yr = document.getElementById('yr');
  if (yr) yr.textContent = new Date().getFullYear();

  /* ---------- Sticky nav shadow ---------- */
  var nav = document.getElementById('nav');
  if (nav) {
    addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', scrollY > 8);
    }, { passive: true });
  }

  /* ---------- Mobile nav drawer ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-nav-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        drawer.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: .12 });
      reveals.forEach(function (el, i) {
        el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
        io.observe(el);
      });
    }
  }

  /* ---------- POS terminal: cycle the highlighted key ---------- */
  var keys = [].slice.call(document.querySelectorAll('#tkeys .t-key'));
  if (keys.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var i = 0;
    setInterval(function () {
      keys.forEach(function (k) { k.classList.remove('active'); });
      keys[i % keys.length].classList.add('active');
      i++;
    }, 1400);
  }

  /* ---------- Region-based address ----------
     Decided by IP only: Paraguay -> Paraguay address, everywhere else -> US. */
  var FLAG_US = '<svg viewBox="0 0 30 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<rect width="30" height="18" fill="#fff"/>'
      + [0, 2, 4, 6, 8, 10, 12].map(function (n) {
          return '<rect width="30" height="1.385" y="' + (n * 1.385).toFixed(3) + '" fill="#B22234"/>';
        }).join('')
      + '<rect width="12" height="9.69" fill="#3C3B6E"/>'
      + [1.6, 4.8, 8.0].map(function (cx) {
          return [1.6, 4, 6.4].map(function (cy) {
            return '<circle cx="' + cx + '" cy="' + cy + '" r=".55" fill="#fff"/>';
          }).join('');
        }).join('')
      + '</svg>';

  var FLAG_PY = '<svg viewBox="0 0 30 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<rect width="30" height="18" fill="#fff"/>'
      + '<rect width="30" height="6" y="0" fill="#D52B1E"/>'
      + '<rect width="30" height="6" y="12" fill="#0038A8"/>'
      + '<circle cx="15" cy="9" r="2.4" fill="#fff" stroke="#0038A8" stroke-width=".5"/>'
      + '<path d="M15 7.2l.45 1.05 1.13.09-.86.74.27 1.1L15 9.6l-.99.58.27-1.1-.86-.74 1.13-.09z" fill="#FFCB00"/>'
      + '</svg>';

  var cfg = window.MB_ADDRESSES || {};
  var ADDRESSES = {
    us: {
      label: cfg.us_label || 'United States',
      flag: FLAG_US,
      lines: (cfg.us_lines || '').split('\n').filter(Boolean),
      tax: cfg.us_tax || ''
    },
    py: {
      label: cfg.py_label || 'Paraguay',
      flag: FLAG_PY,
      lines: (cfg.py_lines || '').split('\n').filter(Boolean),
      tax: cfg.py_tax || ''
    }
  };

  function renderAddress(region) {
    var a = ADDRESSES[region] || ADDRESSES.us;
    var flag = document.getElementById('addrFlag');
    var lines = document.getElementById('addrLines');
    var tax = document.getElementById('addrTax');
    if (!flag || !lines || !tax) return;
    flag.innerHTML = a.flag + ' ' + a.label;
    lines.innerHTML = a.lines.join('<br>');
    tax.textContent = a.tax;
    // the badge is a padded inline-block, so an empty one would still show
    tax.style.display = a.tax ? '' : 'none';
  }

  if (document.getElementById('addrFlag')) {
    // Show the United States address at once, then switch to Paraguay only if
    // the IP lookup places the visitor there. If that request is blocked or
    // fails, the US address simply stays — which is the intended default.
    renderAddress('us');
    (function () {
      if (!window.fetch) return;
      fetch('https://ipapi.co/json/', { cache: 'no-store' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (d) {
          if (!d) return;
          var cc = (d.country_code || '').toUpperCase();
          renderAddress(cc === 'PY' ? 'py' : 'us');
        })
        .catch(function () { /* keep the US default */ });
    })();
  }
})();
